import styled from 'styled-components'
import SpritzCardImage from '../../assets/icons/spritzcard.svg'
import SpritzCardInfoImage from '../../assets/img/spritz-card-info.gif'
import NetworksImage from '../../assets/img/networks.png'
import { breakpoints, Margin } from '@spritz-finance/ui'

export const SpritzCardLogo = styled.img.attrs({
    src: SpritzCardImage,
})`
    width: 122px;
`

export const SpritzCardInfoGif = styled.img.attrs({
    src: SpritzCardInfoImage,
})`
    width: 460px;
    max-width: 100%;
`

export const Networks = styled.img.attrs({
    src: NetworksImage,
})`
    max-width: calc(100vw - 32px);
`

export const CardIntroSpacer = styled.div`
    margin-top: 250px;
    ${breakpoints.small} {
        margin-top: 32px;
    }
`

export const Link = styled.a`
    cursor: pointer;
    text-decoration: underline;
    margin: 0px 3px;
`

export const ContentContainer = styled.div`
    padding ${Margin.Small};
    padding-top: 0;
    width: 528px;
    ${breakpoints.xsmall} {
        width: unset;
    }  
`
export const StyledContentWrapper = styled(ContentContainer)`
    ${breakpoints.xsmall} {
        max-height: unset;
        overflow: unset;
    }
`
